import { jsx as _jsx } from "react/jsx-runtime";
import Image from 'next/image';
import styles from './svg-icon.module.scss';
export const SvgIcon = ({ height, svg, width })=>/*#__PURE__*/ _jsx(Image, {
        alt: `${svg.alt}`,
        className: styles.icon,
        height: height ? Number(height) : undefined,
        src: svg.filename,
        width: width ? Number(width) : undefined
    });

//# sourceMappingURL=SvgIcon.js.map